import { matchMinute, targetLabel } from "@/lib/events";

export const DISC_KEYS = ["amarelo", "vermelho", "ca_por_exibir", "cv_por_exibir", "pp", "pp_por_assinalar"];

export const disciplineEntries = (m, side, key) =>
  m.events
    .filter((e) => e.type === key && e.team === side)
    .sort((a, b) => a.period - b.period || a.seconds - b.seconds)
    .map((e) => ({ id: e.id, who: e.target ? targetLabel(e) : "Sem identificação", minute: matchMinute(e.seconds, e.period, m.half2_reset) }));

export const disciplineText = (m, side, key) => {
  const list = disciplineEntries(m, side, key);
  return list.length ? `${list.length}: ${list.map((x) => `${x.who} (${x.minute})`).join(", ")}` : "0";
};
